import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import type { Playlist } from 'types/playlist'
import type { Track } from 'types/track'
import { getAllSelectedItems } from '@disco/state-management/selectors/selection'
import { getSelectionReturnPath } from 'utils/routing'

const mapStateToProps = state => ({
  selectedItems: getAllSelectedItems(state),
})

// Define connector
const connector = connect(mapStateToProps, {})

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  children: React.ReactNode
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

function SelectionCheckerComponent({ selectedItems, children }: Props) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const returnPath = getSelectionReturnPath(pathname)

  React.useEffect(() => {
    // handle when user left tab open with selection related dialogs, but we no
    // longer have info about selection as it's not encoded in url
    if (selectedItems.length === 0) navigate(returnPath)
  }, [selectedItems.length, navigate, returnPath])

  if (selectedItems.length === 0) return null
  return children as React.ReactElement
}

const SelectionChecker = connector(SelectionCheckerComponent)
export default SelectionChecker
